import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
const store = new Vuex.Store({
  state:{
    currentIndex:'/'
  },
  getters:{
    currentIndex:function(state){
      return state.currentIndex
    }
  },
  mutations:{
    setCurrentIndex(state,index){
      state.currentIndex = index
    }
  },
  actions:{
    setCurrentIndexFun(context,index){
      context.commit('setCurrentIndex',index)
    }
  }
})
export default store